import React, { useEffect, useState } from 'react';
import { Provider, useDispatch, useSelector } from 'react-redux';
import { store } from '../../../../redux/store';
import { getCompany, fetchCompanyDetails } from '../../../../redux/companySlice';
import { http_get } from '../../utils/api_client';
import { API_ENDPOINTS, CONSTS } from '../../utils/endpoints';
import LMLineTab from '../../../organisms/line_tab/LMLineTab';
import Loader from '../../../organisms/loader/Loader';
import ResponsesReport from './ResponsesReport';
import './ResponsesArea.scss';

const fmtDate = (d) => (d ? new Date(d).toLocaleDateString(undefined, { month: 'short', day: 'numeric' }) : '');

// BL-114 — paths-area Responses page (next to Manage Access). Left: paths that
// have at least one response; right: the selected path's report.
const ResponsesArea = () => {
  const dispatch = useDispatch();
  useSelector(getCompany); // keep company populated for LMLineTab
  const [paths, setPaths] = useState(null);
  const [selected, setSelected] = useState(null);
  const [query, setQuery] = useState('');

  useEffect(() => { dispatch(fetchCompanyDetails()); }, [dispatch]);

  useEffect(() => {
    let alive = true;
    http_get(API_ENDPOINTS.MATERIAL_RESPONSES_LIST)
      .then((res) => {
        if (!alive) return;
        const rows = Array.isArray(res.data) ? res.data : [];
        setPaths(rows);
        const wanted = new URLSearchParams(window.location.search || '').get('path');
        const initial = rows.find((r) => r.slug === wanted) || rows[0];
        setSelected(initial ? initial.slug : null);
      })
      .catch(() => { if (alive) setPaths([]); });
    return () => { alive = false; };
  }, []);

  const q = query.trim().toLowerCase();
  const filtered = (paths || []).filter((p) => (p.name || '').toLowerCase().includes(q));

  return (
    <div className="un-page-container__learning-materials ma-page">
      <div className="ma-header-band">
        <div className="ma-header">
          <div className="ma-header__row">
            <h1 className="ma-title">Paths</h1>
          </div>
        </div>
        <LMLineTab defaultTab={2} tabName={CONSTS.PATHS} />
      </div>

      <div className="rra-body">
        {paths === null ? (
          <Loader />
        ) : paths.length === 0 ? (
          <div className="rra-emptybig">
            <span className="rra-emptybig__icon" aria-hidden="true">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none"><path d="M4 20V10M9 20V4M14 20v-7M19 20V8" stroke="#028496" strokeWidth="1.8" strokeLinecap="round" /></svg>
            </span>
            <div className="rra-emptybig__h">No responses yet</div>
            <p className="rra-emptybig__t">
              When learners answer a short answer, long answer, multiple‑choice, or checkbox question in a path,
              their responses show up here — with a summary, an individual table, and CSV export.
            </p>
          </div>
        ) : (
          <div className="rra-split">
            <div className="rra-list">
              <div className="rra-list__h">Paths with responses</div>
              <div className="rra-search">
                <svg width="14" height="14" viewBox="0 0 20 20" fill="none"><circle cx="9" cy="9" r="6" stroke="#9AA6AE" strokeWidth="1.6" /><path d="m14 14 3 3" stroke="#9AA6AE" strokeWidth="1.6" strokeLinecap="round" /></svg>
                <input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Filter paths…" />
              </div>
              {filtered.length === 0 ? (
                <div className="rra-nomatch">No paths match &ldquo;{query}&rdquo;.</div>
              ) : filtered.map((p) => (
                <button
                  key={p.id}
                  type="button"
                  className={`rra-prow${selected === p.slug ? ' on' : ''}`}
                  onClick={() => setSelected(p.slug)}
                >
                  <span className="nm">{p.name}</span>
                  <span className="mt">
                    {p.respondent_count} {p.respondent_count === 1 ? 'respondent' : 'respondents'}
                    {p.last_response_at ? ` · ${fmtDate(p.last_response_at)}` : ''}
                  </span>
                </button>
              ))}
            </div>
            <div className="rra-report">
              {selected ? <ResponsesReport slug={selected} /> : <div className="rra-empty">Select a path.</div>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const AreaIndexPage = () => (
  <Provider store={store}>
    <ResponsesArea />
  </Provider>
);

export default AreaIndexPage;
